import { __read } from "tslib";
import { useEffect, useState } from 'react';
import { globalThemeId, themeIdSnapshot } from '../operations/setGlobalTheme';
export function useThemeId() {
    var _a = __read(useState(themeIdSnapshot), 2), themeId = _a[0], setThemeId = _a[1];
    useEffect(function () {
        var themeIdSubscription = globalThemeId.subscribe(setThemeId);
        return function () {
            themeIdSubscription === null || themeIdSubscription === void 0 ? void 0 : themeIdSubscription.unsubscribe();
        };
    }, []);
    return themeId;
}
//# sourceMappingURL=useThemeId.js.map